module.exports = __webpack_public_path__ + "img/book-1.44d96cad.png";